<template>
    <v-app-bar dense color="white" elevate-on-scroll class="document-editor-header">
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
        <v-container fluid>
            <v-row>
                <v-col :cols="12" :sm="4" class="d-flex">
                    <v-toolbar-title class="title-document">
                        <span class="title-document-name">{{ document && document.name || "" }}</span>
                        <v-chip
                            class="title-document-mode"
                            v-if="wasModified"
                            color="deep-orange lighten-1"
                            outlined
                            x-small
                        >
                            изменен
                        </v-chip>
                    </v-toolbar-title>
                </v-col>
                <v-col :cols="12" :sm="4">
                    <v-pagination
                        v-if="pageCount"
                        v-model="pageIndex"
                        :length="pageCount"
                        :total-visible="7"
                        circle
                    ></v-pagination>
                </v-col>
                <v-col :cols="12" :sm="4">
                    <div class="header-toolbar-buttons">
                        <v-sheet class="zoom" v-if="pageCount">{{ parseInt(zoomValue * 100) }}%</v-sheet>
                        <v-btn icon v-if="pageCount" @click="$emit('zoom')">
                            <v-icon>mdi-aspect-ratio</v-icon>
                        </v-btn>
                        <v-btn icon v-if="isModal" @click="$emit('close')">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-app-bar>
</template>

<script>

export default {
  name: 'DocumentEditorHeader',
  components: {
  },
  props: {
    value: {
        type: Object,
        default: () => ({}),
    },
    zoomValue: {
        type: Number,
        default: 1,
    },
    selectedPageIndex: {
      type: Number,
      default: 1,
    },
    isModal: Boolean,
    wasModified: Boolean,
  },
  data: () => ({
  }),
  computed: {
    pages: {
      get() {
        return this.document?.pages || [];
      }
    },
    pageCount() {
      return this.pages?.length || 0;
    },
    document() {
        return this.value;
    },
    pageIndex: {
        get() {
            return this.selectedPageIndex;
        },
        set(v) {
            this.$emit('update:selected-page-index', v);
        },
    },
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
  .document-editor-header {
    position: sticky;
    top: 0;
    z-index: 2;
    @media(min-width: 960px) {
      top: 0;
    }
    nav {
        padding: 0 20px;
        margin: 0 auto;
    }
    .header-toolbar-buttons {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-left: auto;
        margin-right: -12px;
        .zoom {
          padding: 0 12px;
        }
    }
    .title-document {
        display: flex;
        align-items: center;
        gap: 7px;
        flex: 0 1 auto;
        &-name {
            overflow: hidden;
            text-overflow: ellipsis;
        }
        &-mode {
          color: #333;
          font-size: 10px;
          border-radius: 6px;
          padding: 0 6px;
          border: 1px solid #999;
          height: 20px;
          line-height: 18px;
          min-width: fit-content;
        }
    }
  }
</style>
